import React, { useEffect, useState } from "react";
import {
  FaTwitter,
  FaLinkedinIn,
  FaFacebookF,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaInstagram,
} from "react-icons/fa";
import logoImg from "@/assets/footerlogo.png";
import footerBg from "@/assets/banner/payroll-software-footer-background.webp?w=768;1200;1920&format=webp";
import footerSrcSet from "@/assets/banner/payroll-software-footer-background.webp?w=768;1200;1920&format=webp&as=srcset";
import footer1200 from "@/assets/banner/payroll-software-footer-background.webp?w=1200&format=webp";

import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <footer className="py-10 px-6 relative bg-(--color-dark) overflow-hidden">
      <div className="mx-auto max-w-6xl">
        <div className="relative rounded-xl p-6 md:p-10 backdrop-blur-[35px]  border border-white/20">
          {/* Top Row */}
          <div className="flex flex-col md:flex-row gap-8 md:items-start border-b border-gray-500 pb-6 ">
            <div className="w-full md:w-full text-center md:text-left">
              <p className="text-white max-w-xl mx-auto md:mx-0 text-sm">
                Designed for companies and professionals to streamline salary
                processing and access records anytime, anywhere.
              </p>
            </div>

            {/* Social Icons */}
            <div className="w-full md:w-1/5 flex justify-center md:justify-start mt-4 md:mt-0">
              <div className="flex gap-3">
                <Link
                  to="https://www.facebook.com/waggexx/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Waggexx Facebook page"
                  className="bg-white text-[#10324f] p-2 rounded-full hover:bg-blue-600 hover:text-white transition"
                >
                  <FaFacebookF size={12} aria-hidden="true" />
                </Link>
                <Link
                  to="https://www.instagram.com/waggexx/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Waggexx Instagram page"
                  className="bg-white text-[#10324f] p-2 rounded-full hover:bg-blue-600 hover:text-white transition"
                >
                  <FaInstagram size={12} aria-hidden="true" />
                </Link>
                <Link
                  to="https://www.linkedin.com/company/waggex"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Waggexx LinkedIn page"
                  className="bg-white text-[#10324f] p-2 rounded-full hover:bg-blue-600 hover:text-white transition"
                >
                  <FaLinkedinIn size={12} aria-hidden="true" />
                </Link>
                <Link
                  to="https://x.com/waggexx"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit Waggexx Twitter page"
                  className="bg-white text-[#10324f] p-2 rounded-full hover:bg-blue-600 hover:text-white transition"
                >
                  <FaTwitter size={12} aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row mt-8 gap-6">
            <div className="w-full text-start md:text-left">
              <div className="flex flex-col sm:flex-row justify-between gap-4">
                {/* Quick Links */}

                <div className="sm:w-50">
                  <h2 className="text-white font-semibold mb-3">Company</h2>
                  <ul className="space-y-2 text-sm text-white">
                    <li>
                      <Link
                        to="/become-partner"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Become Partner
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/become-investor"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Become Investor
                      </Link>
                    </li>

                    {/* <li>
                      <Link to="/referral-system" className="hover:underline">
                        Referral System
                      </Link>
                    </li> */}
                    <li>
                      <Link
                        to="/hiring"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        We Are Hiring
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="sm:w-50">
                  <h2 className="text-white font-semibold mb-3">Quick Links</h2>
                  <ul className="space-y-2 text-sm text-white">
                    <li>
                      <Link
                        to="/about-us"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        About Us
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/how-to-use"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        How to Use
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="https://www.waggex.com/blog/"
                        target="_blank"
                        className="hover:underline"
                      >
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pricing"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Pricing
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="sm:w-60">
                  <h2 className="text-white font-semibold mb-3">Services</h2>
                  <ul className="space-y-2 text-sm text-white">
                    <li>
                      <Link
                        to="/best-payroll-software-in-chandigarh"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Payroll Software in Chandigarh
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/best-payroll-software-in-mohali"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Payroll Software in Mohali
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/best-payroll-software-in-delhi"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Payroll Software in Delhi
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/best-payroll-software-in-gurgaon"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Payroll Software in Gurgaon
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/best-payroll-software-in-noida"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Payroll Software in Noida
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/best-payroll-software-in-mumbai"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Payroll Software in Mumbai
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/best-payroll-software-in-bangalore"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Payroll Software in Bangalore
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/best-payroll-software-in-hyderabad"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Payroll Software in Hyderabad
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/best-payroll-software-in-chennai"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Payroll Software in Chennai
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="sm:w-40">
                  <h2 className="text-white font-semibold mb-3">Support</h2>
                  <ul className="space-y-2 text-sm text-white">
                    <li>
                      <Link
                        to="/privacy-policy"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/cookies-policy"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Cookies Policy
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/terms-conditions"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Terms & Conditions
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/refund-and-cancellation"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Refund & Cancellation
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact-us"
                        onClick={() => window.scrollTo(0, 0)}
                        className="hover:underline"
                      >
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="w-70">
              <div className="space-y-4 text-sm text-white">
                {/* Email */}
                <div className="flex items-center space-x-3 group cursor-pointer">
                  <div className="bg-white p-2 rounded-full text-[#10324f] group-hover:bg-blue-600 group-hover:text-white transition">
                    <FaEnvelope size={12} aria-hidden="true" />
                  </div>
                  <span className="group-hover:text-white transition">
                    Info@waggex.com
                  </span>
                </div>

                {/* Phone */}
                <div className="flex items-center space-x-3 group cursor-pointer">
                  <div className="bg-white p-2 rounded-full text-[#10324f] group-hover:bg-blue-600 group-hover:text-white transition">
                    <FaPhone
                      size={12}
                      className="rotate-90"
                      aria-hidden="true"
                    />
                  </div>
                  <span className="group-hover:text-white transition">
                    91 - 8571913707
                  </span>
                </div>

                {/* Address */}
                <div className="flex items-center space-x-3 group cursor-pointer">
                  <div className="bg-white p-2 rounded-full text-[#10324f] group-hover:bg-blue-600 group-hover:text-white transition">
                    <FaMapMarkerAlt size={12} aria-hidden="true" />
                  </div>
                  <span className="group-hover:text-white transition">
                    Sahibzada Ajit Singh Nagar, Punjab 140307
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6 border-t border-gray-600 pt-4">
            <div className="flex flex-col items-center justify-between gap-3 text-sm text-white md:flex-row">
              {/* Left Side */}
              <div className="text-center md:text-left">
                © {new Date().getFullYear()} Waggex. Operated by DEEP. All
                rights reserved.
              </div>

              {/* Right Side */}
              <div className="flex items-center gap-2 text-center md:text-right">
                {/* India Flag SVG */}
                <img
                  src="/indiaflag.png"
                  alt="India Flag"
                  width="24"
                  height="24"
                  className="object-cover"
                />

                <span className="font-roboto font-normal text-sm">
                  Made in India
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
